import { useContext, createContext, ReactNode } from 'react';
import { logEvent } from '../utils/logger';
import * as packageJson from '../../package.json';
import { config } from '../config';
import { useSessionId, SessionIdProvider } from 'neon-utils';
import { AuthLogAppInfo } from 'neon-auth0';

interface Props {
  children: ReactNode;
}

const SessionDataContext = createContext<AuthLogAppInfo>({} as any);
export const useSessionData = () => useContext(SessionDataContext);

const logSessionIdEvent = (message: string, data: unknown) => {
  logEvent({ event: 'session_id_provider', message, data } as any);
};

const SessionDataContextWrapper = ({ children }: Props) => {
  const sessionId = useSessionId();

  const sessionData = {
    sessionId,
    appName: packageJson.name,
    appVersion: config.version
  };

  return <SessionDataContext.Provider value={sessionData}>{children}</SessionDataContext.Provider>;
};

export const SessionDataProvider = ({ children }: Props) => {
  return (
    <SessionIdProvider log={logSessionIdEvent}>
      <SessionDataContextWrapper>{children}</SessionDataContextWrapper>
    </SessionIdProvider>
  );
};
